import { createSelector } from 'reselect';

import { PreloaderConfig } from '../reducers/config';
import { RootState } from '../types';
import { definitionsSelector, preloaderSelector } from './config';
import { gameSelector } from './game';
import { roundIdSelector } from './round';

const defaultPreloaderConfig: PreloaderConfig = {
  poweredBy: '',
  fullScreenImage: false,
  showInfoMessage: false,
  showLogo: false,
  showGameName: false,
  showGameLogo: false,
};

export const preloaderConfigSelector = createSelector(
  definitionsSelector,
  preloaderSelector,
  gameSelector,
  (definitions, preloader, game) => {
    const {
      preloaderEnablePowerBy,
      preloaderIconUrl,
      poweredByIconUrl,
      gameLogoUrl,
      poweredBy,
      fullScreenImage,
      preloaderBackgroundUrl,
      showInfoMessage,
      showLogo,
      showGameName,
      showGameLogo,
    } = preloader ?? defaultPreloaderConfig;
    const iconUrl = preloaderIconUrl
      ? `${definitions.OPERATOR_ASSETS}${preloaderIconUrl}`
      : undefined;
    const poweredByUrl = poweredByIconUrl
      ? `${definitions.OPERATOR_ASSETS}${poweredByIconUrl}`
      : undefined;
    const bgUrl = preloaderBackgroundUrl
      ? `${definitions.OPERATOR_ASSETS}${preloaderBackgroundUrl}`
      : undefined;
    const gameLogo = gameLogoUrl
      ? `${definitions.OPERATOR_ASSETS}${gameLogoUrl}`
      : undefined;

    return {
      image: bgUrl,
      ...(preloaderEnablePowerBy && {
        poweredBy: {
          label: poweredBy,
          logo: poweredByUrl,
        },
      }),
      showInfoMessage,
      logo: iconUrl,
      gameLogo,
      gameName: game.name,
      fullScreenImage,
      showLogo: showLogo && !showGameLogo, // if table has game logo, don't show operator logo
      showGameName: showGameName && !showGameLogo, // if table has game logo, don't show game name
      showGameLogo,
    };
  }
);

export const preloaderHiddenSelector = (state: RootState) => !state.preloader.open;

export const isLoadedSelector = createSelector(roundIdSelector, (u) => !!u);
